/* eslint-disable eqeqeq *///忽略==的警告
import { meshLog } from "./spUtils";
//16进制求和
export const sumHexBytes = (hexStr) => {
  let sum = 0;
  for (let i = 0; i < hexStr.length; i += 2) {
    // 每两个字符作为一个字节处理
    let byte = hexStr.slice(i, i + 2);
    // 将16进制字符串转换为10进制数
    sum += parseInt(byte, 16);
  }
  let decimalNumber = sum;
  let hexString = decimalNumber.toString(16);
  let lastTwoDigits = (hexString.toString().slice(-2));
  // meshLog('hexString', hexString);
  if (lastTwoDigits.length == 1) {
    lastTwoDigits = '0' + lastTwoDigits;
  }
  return lastTwoDigits;

}

//两个字节，反转
export const getOctets2Msg = (oldNum) => {
  let mStr = oldNum.toString(16) + '';
  if (mStr.length == 1) {
    mStr = '0' + mStr + '00';
  } else if (mStr.length == 2) {
    mStr = mStr + '00';
  } else if (mStr.length == 3) {
    let str = '0' + mStr;
    mStr = str.substring(2, 4) + str.substring(0, 2);
  } else if (mStr.length == 4) {
    let str = mStr;
    mStr = str.substring(2, 4) + str.substring(0, 2);
  }
  return mStr;
}
//int转16进制 转成2个数
export const transIntToHex2Str = (num) => {
  let str = (num.toString(16) + '').toLocaleUpperCase();
  if (str.length == 1) {
    str = '0' + str;
  }
  return str;
}
//int转16进制 转成3个数
export const transIntToHex3Str = (num) => {
  let str = (num.toString(16) + '').toLocaleUpperCase();
  if (str.length == 1) {
    str = '00' + str;
  } else if (str.length == 0) {
    str = '0' + str;
  }
  return str;
}
//0609需要的 转成4个数
export const transIntToHex4Str = (num) => {
  let str = (num.toString(16) + '').toLocaleUpperCase();
  if (str.length == 1) {
    str = '000' + str;
  } else if (str.length == 2) {
    str = '00' + str;
  } else if (str.length == 3) {
    str = '0' + str;
  }
  return str;
}

//mac地址翻转
export const bigEndianToLittleEndian = (hexStr) => {
  // 确保字符串长度是偶数

  if (typeof hexStr !== 'string') {
    // console.error("Input must be a string");
    return '';
  }

  if (hexStr.length % 2 !== 0) {
    throw new Error('Input string must have an even length');
  }

  // 将十六进制字符串分解为字节数组
  const bytes = [];
  for (let i = 0; i < hexStr.length; i += 2) {
    bytes.push(parseInt(hexStr.substr(i, 2), 16));
  }

  // 反转字节数组以实现从大端到小端的转换
  const littleEndianBytes = bytes.reverse();

  // 将字节数组转换回十六进制字符串
  let result = '';
  for (const byte of littleEndianBytes) {
    result += byte.toString(16).padStart(2, '0');
  }

  return result.toUpperCase(); // 返回大写的十六进制字符串
}


//16进制数如何转换为负数十进制
export const hexToNegativeDecimal = (hexStr) => {
  // 移除前缀并统一大写
  hexStr = hexStr.replace(/^0x/i, '').toUpperCase();

  // 判断是否为负数（首位8-F）
  const isNegative = /^[8-9A-F]/.test(hexStr[0]);

  if (!isNegative) {
    return parseInt(hexStr, 16);
  }

  // 计算补码（取反+1）
  const bits = hexStr.length * 4;
  const maxValue = Math.pow(2, bits);
  const rawValue = parseInt(hexStr, 16);

  // 补码公式：value - 2^n
  return rawValue - maxValue;
}

//int转16进制
export const getMaxTrimInfo = (mMaxStr) => {
  let info = '100%';
  if (typeof (mMaxStr) == 'undefined' || mMaxStr == 'FFFF' || mMaxStr == '') {
    info = '100%'
  } else {
    let m = (parseInt(mMaxStr, 16) / 655.35);
    info = parseInt(m + 0.5) + '%'
  }
  return info;
}

export const transIntTo2Str = (num) => {
  let str = num + '';
  if (str.length == 1) {
    str = '0' + str;
  }
  return str;
}

//获取32位随机数
export const getRandomStr = (count) => {
  let hexString = '';
  for (let i = 0; i < count; i++) {
    // 生成一个0到15之间的随机数，然后转换为16进制并拼接
    hexString += Math.floor(Math.random() * 16).toString(16);
  }
  return hexString.toUpperCase();
}
//传入一个秒数，返回分钟和秒数
export const convertSecondsToTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  let holdTime = []
  holdTime[0] = minutes + 'min'
  holdTime[1] = remainingSeconds + 's'
  // console.log(holdTime);
  return holdTime;
}
//取前四位字节

export const trans4toString = (str) => {
  if (typeof str !== 'string') {  //处理异步问题
    // console.error("Input must be a string");
    return '';
  }
  const slicedText = str.slice(0, 4); // 截取前四位字节
  meshLog('text', slicedText);
  return slicedText;
}

//计算两个时间差多少天
export const getDaysBetweenDates = (date1, date2) => {
  const oneDay = 1000 * 60 * 60 * 24;
  const differenceMs = Math.abs(date2.getTime() - date1.getTime());
  return Math.floor(differenceMs / oneDay);
}

//随机出一个颜色
export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
